<template>
    <div>
        <v-layout style="margin: 0 5px" v-if="!ride">
            <v-flex xs4>
                <v-select
                        :label="$t('monitoring.pathDrawer.selectRideType')"
                        :items="rideTypes"
                        v-model="type"
                ></v-select>
            </v-flex>
            <v-flex xs4>
                <v-text-field :disabled="loading" v-model="ride_id" @keypress.enter="$refs.submit.$emit('click')"
                              type="number" min="1" :label="type === 'ride' ? $t('monitoring.pathDrawer.rideId') : $t('monitoring.pathDrawer.ghostRideId')">
                </v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-btn :loading="loading" color="success" ref="submit" @click="search">{{ $t("common.search") }}</v-btn>
            </v-flex>
        </v-layout>
        <div v-show="!!route" ref="map" id="map" style="height:75vh;">
            <div class="color-indicator">
                <span class="color-identifier"
                      style="background-color: #efefef;min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;">{{ $t("monitoring.pathDrawer.paxPick") }}</span>
                <span class="color-identifier"
                      style="background-color: black;min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;">{{ $t("monitoring.pathDrawer.paxPull") }}</span>
                <span class="color-identifier"
                      :style="'background-color: '+api.CONSTANTS.COLOR_INDICATORS.PENDING+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{ $t("monitoring.pathDrawer.pending") }}</span>
                <span class="color-identifier"
                      :style="'background-color: '+api.CONSTANTS.COLOR_INDICATORS.CONFIRMED+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{ $t("monitoring.pathDrawer.accepted") }}</span>
                <span class="color-identifier"
                      :style="'background-color: '+api.CONSTANTS.COLOR_INDICATORS.STARTED+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{ $t("monitoring.pathDrawer.started") }}</span>
                <span class="color-identifier"
                      :style="'background-color: '+api.CONSTANTS.COLOR_INDICATORS.ARRIVED+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{ $t("monitoring.pathDrawer.arrived") }}</span>
                <span class="color-identifier"
                      :style="'background-color: '+api.CONSTANTS.COLOR_INDICATORS.PICKED_UP+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{ $t("monitoring.pathDrawer.pickedUp") }}</span>
                <span class="color-identifier"
                      :style="'background-color: '+api.CONSTANTS.COLOR_INDICATORS.DONE+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{ $t("monitoring.pathDrawer.done") }}</span>
                <span class="color-identifier"
                      :style="'background-color: '+api.CONSTANTS.COLOR_INDICATORS.STOP+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{ $t("monitoring.pathDrawer.stop") }}</span>

            </div>
        </div>
    </div>
</template>

<script>
    import Mapbox from "mapbox-gl";

    export default {
        name: "PathDrawer",
        title() {
            return this.$t("monitoring.pathDrawer.title");
        },
        props: {
            ride: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                route: [],
                actions: [],
                ride_id: null,
                loading: false,
                map: null,
                type: 'ride',
                COLOR_INDICATORS: {
                    PENDING: "#9f43cf",
                    CONFIRMED: "#8e8e88",
                    STARTED: "#428bca",
                    ARRIVED: "#ffa60c",
                    PICKED_UP: "#e04b4a",
                    DONE: "#69b869",
                    PASSENGER_PICKUP: "#efefef",
                    PASSENGER_DONE: "black",
                    PASSENGER_STOP: "#b3e6cc"
                }
            }
        },
        computed: {
            rideTypes() {
                return [
                    {text: this.$t("monitoring.pathDrawer.ride"), value: 'ride'},
                    {text: this.$t("monitoring.pathDrawer.ghostRide"), value: 'ghost_ride'}
                ];
            }
        },
        mounted() {
            Mapbox.accessToken = this.api.mapBox.accessToken;
            this.map = new Mapbox.Map(Object.assign({
                    container: 'map',
                    ...this.api.mapBox
                },
                {center: [36.2739299, 33.506888]}
            ));
            this.ride_id = this.ride;
            if (this.ride_id)
                this.search();
        },
        methods: {
            setMapUp() {
                if (this.route.length < 2) {
                    this.route = [{lng: 36.2739299, lat: 33.506888}, {lng: 36.2739299, lat: 33.506888}];
                }
                Mapbox.accessToken = this.api.mapBox.accessToken;
                this.map = new Mapbox.Map(Object.assign({
                        container: 'map',
                        ...this.api.mapBox
                    },
                    {center: [this.route[0].lng, this.route[0].lat]}
                ));
                let geojson = {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "geometry": {
                            "type": "LineString",
                            "coordinates": this.route.map(({lng, lat}) => [lng, lat])
                        }
                    }]
                };
                this.map.on('load',
                    () => {
                        this.map.addLayer({
                            'id': 'line-animation',
                            'type': 'line',
                            'source': {
                                'type': 'geojson',
                                'data': geojson
                            },
                            'layout': {
                                'line-cap': 'round',
                                'line-join': 'round'
                            },
                            'paint': {
                                'line-color': '#ed6498',
                                'line-width': 5,
                                'line-opacity': .8
                            }
                        });
                        const markers = [];

                        this.actions.forEach(elem => {
                            if (!this.COLOR_INDICATORS[elem.status]) {
                                return;
                            }
                            markers.push(new Mapbox.Marker({color: this.COLOR_INDICATORS[elem.status], symbol: 'S'}));
                            let index = markers.length - 1;
                            console.log([elem.location.coordinates[0], elem.location.coordinates[1]]);
                            markers[index].setLngLat([elem.location.coordinates[0], elem.location.coordinates[1]]);
                            markers[index].addTo(this.map);
                        });
                        this.map.resize();
                    });
                this.map.addControl(new Mapbox.FullscreenControl());
            },
            search() {
                if (!!this.ride_id) {
                    this.loading = true;
                    if (this.type === 'ride')
                        this.axios.get(`ride/${this.ride_id}/route`)
                            .then(res => {
                                this.route = res.data.data.route;
                                this.actions = res.data.data.actions;
                                this.setMapUp();
                            })
                            .catch(err => console.log(err.message))
                            .finally(() => this.loading = false);
                    else
                        this.axios.get(this.api.ACTIONS.GHOST_RIDES + '/' + this.ride_id)
                            .then(res => {
                                this.route = res.data.data.tracking.route;
                                if (this.route.length > 1) {
                                    this.actions = [{
                                        location: this.route[0],
                                        status: 'STARTED'
                                    }, {
                                        location: this.route[this.route.length - 1],
                                        status: 'DONE'
                                    }];
                                }
                                this.setMapUp();
                            })
                            .catch(err => console.log(err.message))
                            .finally(() => this.loading = false)
                }
            }
        }
    }
</script>

<style scoped>
    .smooth-height {
        transition: height 0.5s;
    }

    .color-indicator {
        position: absolute;
        top: 0;
        left: 0;
        margin: 16px;
        z-index: 1;
    }
</style>
